import { createApp } from 'vue'
import DueroIconfont from '@dustess/duero-iconfont'
import './assets/scss/frame.scss'
import dsCloud from '@plugins/ds-cloud'
import App from './App'
import newRouter from './router'
import store from './store'
import h5 from '@/h5/index'
import registerGComponents from '@/plugins/register-g-components'
import '@dustess/cf-design-mobile/lib/index.css'

const gVm = createApp(App)
const { router } = newRouter(gVm)
gVm.use(store)
  .use(router)
  .use(DueroIconfont, { // icon组件
    fontClassUrl: '//at.alicdn.com/t/c/font_3181568_alifuldh4uk.css',
    symbolUrl: '//at.alicdn.com/t/c/font_3181568_alifuldh4uk.js',
    componentName: 'DueroIconfont',
    projectId: '3181568',
  })
  .use(dsCloud) // ProcessBase
  .use(registerGComponents) // 注册全局sdk

gVm.use(h5, { // 授权逻辑
  newVue() {
    gVm.mount('#app')
  },
})
